import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ThemeConstantService } from "src/app/shared/services/theme-constant.service";
import { AppsService } from "src/app/shared/services/apps.service";
import { AtomServiceService } from "src/app/shared/services/atom-service.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";
import { Location } from "@angular/common";

@Component({
  selector: "app-states",
  templateUrl: "./states.component.html",
  styleUrls: ["./states.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatesComponent implements OnInit {
  shwDeleteCnfrm: boolean;
  constructor(
    private fb: FormBuilder,
    private themeService: ThemeConstantService,
    public apiSrv: AppsService,
    public atmSrv: AtomServiceService,
    private message: NzMessageService,
    private modal: NzModalService,
    private location: Location,
    private nzMessageService: NzMessageService
  ) {}

  USER_PERMISSIONS: any = {
    slct_in: 0,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  usrAcsErrMsg: boolean = false;
  columnDefs;
  mainMessage;
  loader;
  gridData;
  shwSidebar;
  sidebarHeading;
  stateForm: FormGroup;
  shwLdng;
  editdata;
  delData;
  delete: boolean = false;

  ngOnInit() {
    this.stateForm = new FormGroup({
      ste_nm: new FormControl(""),
    });
    this.getGridData();
  }

  getGridData() {
    this.mainMessage = null;
    this.loader = true;
    this.apiSrv.get("/core/api/master/states/list").subscribe((res) => {
      this.loader = false;
      if (res["status"] == 200) {
        this.gridData = res["data"];
      }
    });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "plus",
        text: "Add State",
        onClick: this.addNew.bind(this),
      },
    });
  }

  addNew() {
    this.editdata = null;
    this.shwSidebar = true;
    this.sidebarHeading = "Add State";
    this.stateForm.reset();
  }

  editRecord(data) {
    this.editdata = data;
    this.shwSidebar = true;
    this.sidebarHeading = "Edit State";
    this.stateForm.patchValue({
      ste_nm: data.ste_nm,
    });
  }

  deleteRecord(data) {
    this.delData = data;
    this.shwDeleteCnfrm = true;
  }

  closeSidebar() {
    this.shwSidebar = false;
  }

  submitForm() {
    if (this.stateForm.valid) {
      this.shwLdng = true;
      let params: any = {
        ste_nm: this.stateForm.value.ste_nm,
      };

      if (this.editdata) {
        params.ste_id = this.editdata.ste_id;
        this.apiSrv
          .put(
            this.stateForm.value,
            `core/api/master/states/${this.editdata.ste_id}`
          )
          .subscribe((res) => {
            this.shwLdng = false;
            if (res["status"] == 200) {
              this.message.success(res["message"]);
              this.shwSidebar = false;
              this.getGridData();
            }
          });
      } else {
        this.apiSrv
          .post(this.stateForm.value, "core/api/master/states")
          .subscribe((res) => {
            this.shwLdng = false;
            if (res["status"] == 200) {
              this.message.success(res["message"]);
              this.shwSidebar = false;
              this.getGridData();
            }
          });
      }
    } else {
      Object.values(this.stateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsTouched();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  confirmDelete() {
    this.shwLdng = true;
    this.apiSrv
      .delete(`core/api/master/states/${this.delData.ste_id}`)
      .subscribe((res) => {
        this.shwLdng = false;
        if (res["status"] == 200) {
          this.message.success(res["message"]);
          this.shwDeleteCnfrm = false;
          this.getGridData();
        }
      });
  }

  cancelDelete() {
    this.shwDeleteCnfrm = false;
  }
}
